import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const UserManagement = lazy(() => import('../components/settings/user-management/UserManagement'));
const PasswordPolicy = lazy(() => import('../components/settings/password-policy/PasswordPolicy'));
const Passkeys = lazy(() => import('../components/settings/passkeys/Passkeys'));

export const settingsRoutes = (
  <>
    <Route path="/user-management" element={<Navigate to="/settings/users" replace />} />
    <Route path="/settings" element={<Navigate to="/settings/users" replace />} />
    <Route path="/settings/users" element={<UserManagement />} />
    <Route path="/settings/user-management" element={<Navigate to="/settings/users" replace />} />
    <Route path="/settings/password-policy" element={<PasswordPolicy />} />
    <Route path="/settings/passkeys" element={<Passkeys />} />
  </>
);
